module.exports = __webpack_public_path__ + "img/study-statistics-icon02.06b6d4a1.png";